module.exports = __webpack_public_path__ + "img/notifications-empty.c29eaa03.svg";